module.exports = __webpack_public_path__ + "static/img/case-zlj-page-bg-02.f854455.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/zlj/case-zlj-page-bg-02.jpg
// module id = 6lag
// module chunks = 1